import React, { useEffect } from 'react';

/**
 * AddressSection - Contact and Map section
 * Exact content from original index.html
 */
function AddressSection() {
  useEffect(() => {
    // Initialize Google Map after component mount
    if (window.google && window.google.maps) {
      const initMap = () => {
        const myLatlng = new window.google.maps.LatLng(37.2090, -93.2923); // Springfield, MO
        
        const mapOptions = {
          zoom: 14,
          center: myLatlng,
          styles: [
            {"featureType": "water", "elementType": "geometry", "stylers": [{"color": "#e9e9e9"}, {"lightness": 17}]},
            {"featureType": "landscape", "elementType": "geometry", "stylers": [{"color": "#f5f5f5"}, {"lightness": 20}]},
            {"featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{"color": "#ffffff"}, {"lightness": 17}]},
            {"featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{"color": "#ffffff"}, {"lightness": 29}, {"weight": 0.2}]},
            {"featureType": "road.arterial", "elementType": "geometry", "stylers": [{"color": "#ffffff"}, {"lightness": 18}]},
            {"featureType": "road.local", "elementType": "geometry", "stylers": [{"color": "#ffffff"}, {"lightness": 16}]},
            {"featureType": "poi", "elementType": "geometry", "stylers": [{"color": "#f5f5f5"}, {"lightness": 21}]},
            {"featureType": "poi.park", "elementType": "geometry", "stylers": [{"color": "#dedede"}, {"lightness": 21}]},
            {"elementType": "labels.text.stroke", "stylers": [{"visibility": "on"}, {"color": "#ffffff"}, {"lightness": 16}]},
            {"elementType": "labels.text.fill", "stylers": [{"saturation": 36}, {"color": "#333333"}, {"lightness": 40}]},
            {"elementType": "labels.icon", "stylers": [{"visibility": "off"}]},
            {"featureType": "transit", "elementType": "geometry", "stylers": [{"color": "#f2f2f2"}, {"lightness": 19}]},
            {"featureType": "administrative", "elementType": "geometry.fill", "stylers": [{"color": "#fefefe"}, {"lightness": 20}]},
            {"featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{"color": "#fefefe"}, {"lightness": 17}, {"weight": 1.2}]}
          ]
        };
        
        const map = new window.google.maps.Map(document.getElementById('map'), mapOptions);
        
        new window.google.maps.Marker({
          position: myLatlng,
          map: map,
          title: 'DataFlex Energy Partners'
        });
      };
      
      setTimeout(initMap, 100);
    }
  }, []);

  return (
    <section id="contact" className="p-0">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-md-6 p-0">
            <div className="address-box title mb-0 bg-img4">
              {/* overlay */}
              <div className="bg-overlay gradient-bg1 opacity-8"></div>
              <div className="address-text text-center text-white position-relative wow fadeInUp">
                <h6 className="mb-3">From east coast to west, across all publicly owned</h6>
                {/* title */}
                <h2 className="mb-4">US Energy Grids.</h2>
                {/* Address */}
                <p className="mb-3 text-white">
                  <b>OFFICE:</b> Springfield, MO
                </p>
                {/* Email */}
                <p className="mb-3 text-white">
                  <b>CONTACT:</b> <a href="mailto:projects@dataflexep.com">projects@dataflexep.com</a>
                </p>
                {/* Social Icon */}
                <div className="address-social">
                  <ul className="list-unstyled">
                    <li>
                      <a className="linkedin-text-hvr" href="https://www.linkedin.com/company/dataflexenergy" target="_blank" rel="noopener noreferrer">
                        <i className="fa fa-linkedin" aria-hidden="true"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 p-0">
            <div id="map" className="half-map bg-img-map"></div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AddressSection;